var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.045 12.7099L2.023 20.9679C1.96739 20.994 1.90611 21.0057 1.84478 21.002C1.78345 20.9983 1.72404 20.9792 1.67199 20.9466C1.61993 20.9139 1.57691 20.8688 1.54686 20.8152C1.51681 20.7616 1.5007 20.7013 1.5 20.6399V15.3279C1.5001 15.2406 1.5306 15.1561 1.58627 15.089C1.64195 15.0218 1.71929 14.9761 1.805 14.9599L13.412 12.7569C14.226 12.6019 14.226 11.4369 13.412 11.2829L1.805 9.07986C1.71929 9.06357 1.64195 9.01792 1.58627 8.95075C1.5306 8.88358 1.5001 8.7991 1.5 8.71186V3.40186C1.5 3.13386 1.776 2.92186 2.023 3.02786L22.045 11.3329C22.1794 11.3909 22.2939 11.4871 22.3743 11.6094C22.4547 11.7317 22.4976 11.8749 22.4976 12.0214C22.4976 12.1678 22.4547 12.311 22.3743 12.4333C22.2939 12.5557 22.1794 12.6518 22.045 12.7099Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.23c19f557c7205c6b85ee6b5387ab65d.svg";
export { ForwardRef as ReactComponent };